import React from "react";

export const ActionNameMapping = {
  emailNotifications: "Email Notifications",
  fieldUpdates: "Field Updates",
  createActivityAction: "Create Activity",
  createDealAction: "Create Deal",
  leadToJunkAction: "Convert Lead To Junk",
  sequenceAction: "Sequences",
  dealToLeadAction: "Deal to Lead",
  dealArchiveAction: "Deal Archive",
  dealLostReasonAction: "Deal Lost Reason",
};

export const moduleToActionMapping = {
  lead: [
    {
      displayName: "Email Notifications",
      actionName: "emailNotifications",
      description: "",
      moduleName: "lead",
    },
    {
      displayName: "Field Updates",
      actionName: "fieldUpdates",
      description: "",
      moduleName: "lead",
    },
    {
      displayName: "Create Activity",
      actionName: "createActivityAction",
      description: "",
      moduleName: "lead",
    },
    {
      displayName: "Create Deal",
      actionName: "createDealAction",
      description: "",
      moduleName: "lead",
    },
    {
      displayName: "Convert Lead To Junk",
      actionName: "leadToJunkAction",
      description: "",
      moduleName: "deal",
    },
    {
      displayName: "Subscribe To Cadence",
      actionName: "sequenceAction",
      description: "",
      moduleName: "lead",
    },
  ],
  deal: [
    {
      displayName: "Email Notifications",
      actionName: "emailNotifications",
      description: "",
      moduleName: "deal",
    },
    {
      displayName: "Field Updates",
      actionName: "fieldUpdates",
      description: "",
      moduleName: "deal",
    },
    {
      displayName: "Create Activity",
      actionName: "createActivityAction",
      description: "",
      moduleName: "deal",
    },
    {
      displayName: "Deal to Lead",
      actionName: "dealToLeadAction",
      description: "",
      moduleName: "deal",
    },
    {
      displayName: "Deal Lost Reason",
      actionName: "dealLostReasonAction",
      description: "",
      moduleName: "deal",
    },
    {
      displayName: "Deal Archive",
      actionName: "dealArchiveAction",
      description: "",
      moduleName: "deal",
    },
  ],
  person: [
    {
      displayName: "Email Notifications",
      actionName: "emailNotifications",
      description: "",
      moduleName: "person",
    },
    {
      displayName: "Field Updates",
      actionName: "fieldUpdates",
      description: "",
      moduleName: "person",
    },
    {
      displayName: "Create Activity",
      actionName: "createActivityAction",
      description: "",
      moduleName: "person",
    },
    {
      displayName: "Create Deal",
      actionName: "createDealAction",
      description: "",
      moduleName: "person",
    },
    {
      displayName: "Subscribe To Cadence",
      actionName: "sequenceAction",
      description: "",
      moduleName: "person",
    },
  ],
  company: [
    {
      displayName: "Email Notifications",
      actionName: "emailNotifications",
      description: "",
      moduleName: "company",
    },
    {
      displayName: "Field Updates",
      actionName: "fieldUpdates",
      description: "",
      moduleName: "company",
    },
    {
      displayName: "Create Activity",
      actionName: "createActivityAction",
      description: "",
      moduleName: "company",
    },
  ],
};

export const pageMapping = {
  lead: { page: "Leads", pageSub: "lead" },
  person: { page: "People", pageSub: "people" },
  people: { page: "People", pageSub: "people" },
  company: { page: "Companies", pageSub: "company" },
  deal: { page: "Deals", pageSub: "deal" },
  marketing: { page: "marketing", pageSub: "marketing" },
};

export const optionsMapping = {
  lead: [
    { value: "lead", label: "Lead" },
    { value: "company", label: "Company" },
  ],
  person: [
    { value: "person", label: "People" },
    { value: "company", label: "Company" },
  ],
  company: [{ value: "company", label: "Company" }],
  deal: [
    { value: "deal", label: "Deal" },
    { value: "person", label: "People" },
    { value: "company", label: "Company" },
  ],
  marketing: [{ value: "marketing", label: "Marketing" }],
};

export const actionTypeMapping = {
  all: ["dealArchiveAction", "dealToLeadAction", "emailNotifications", "fieldUpdates", "leadToJunkAction", "createActivityAction", "createDealAction", "sequenceAction", "dealLostReasonAction"],
  array: ["emailNotifications", "fieldUpdates"],
  object: ["leadToJunkAction", "createActivityAction", "createDealAction", "sequenceAction", "dealLostReasonAction"],
  nonEdit: ["dealArchiveAction", "dealToLeadAction"],
  editNeeded: ["emailNotifications", "fieldUpdates", "leadToJunkAction", "createActivityAction", "createDealAction", "sequenceAction", "dealLostReasonAction"],
  noSubData: ["dealArchiveAction", "dealToLeadAction"],
  noDuplication: ["leadToJunkAction", "dealArchiveAction", "dealToLeadAction", "dealLostReasonAction"],
  noName: ["dealArchiveAction", "dealToLeadAction", "leadToJunkAction", "dealLostReasonAction", "createDealAction"],
};

export const activityTimeArray = [
  {
    name: "In 1h",
    key: "1hr",
    duration: 3600000,
  },
  {
    name: "In 3h",
    key: "3hr",
    duration: 10800000,
  },
  {
    name: "Tomorrow",
    key: "tomorrow",
    duration: 86400000,
  },
];

export const expectedCloseDateArray = [
  {
    name: "In 1h",
    key: "1hr",
    duration: 3600000,
  },
  {
    name: "In 3h",
    key: "3hr",
    duration: 10800000,
  },
  {
    name: "Tomorrow",
    key: "tomorrow",
    duration: 86400000,
  },
];

export const workflowFlowData = [
  {
    type: "name",
    icon: (
      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.28271 7.28622C8.59377 7.28622 8.02013 7.78389 7.89914 8.43818L2.37046 8.43826C1.5084 8.43826 1.47537 7.63292 1.47448 7.54229V6.39033C1.47448 5.52828 2.27983 5.49525 2.37046 5.49436L4.44296 5.49427C4.56377 6.14864 5.13777 6.64622 5.82662 6.64622C6.51556 6.64622 7.0892 6.14855 7.21018 5.49427H9.15464C10.2684 5.49427 10.5627 4.57328 10.5627 4.08622V2.93427C10.5627 1.82051 9.6417 1.52622 9.15464 1.52622H3.75396C3.63315 0.871845 3.0593 0.374268 2.37039 0.374268C1.59405 0.374268 0.962344 1.00597 0.962344 1.78231C0.962344 2.55866 1.59405 3.19036 2.37039 3.19036C3.05933 3.19036 3.63306 2.69269 3.75396 2.0384L9.15327 2.03832C9.24514 2.03921 10.0506 2.07224 10.0506 2.93429V4.08501C10.0497 4.1768 10.0167 4.98234 9.15462 4.98234H7.20998C7.08917 4.32796 6.51533 3.83038 5.82641 3.83038C5.1375 3.83038 4.56374 4.32805 4.44276 4.98234H2.37044C1.88337 4.98234 0.96239 5.27662 0.96239 6.39038V7.54234C0.96239 8.0294 1.25668 8.95038 2.37044 8.95038H7.89912C8.01993 9.60476 8.59377 10.1023 9.28269 10.1023C10.059 10.1023 10.6907 9.47064 10.6907 8.69429C10.6907 7.91795 10.059 7.28625 9.28269 7.28625L9.28271 7.28622ZM2.37048 2.67822C1.87638 2.67822 1.4745 2.27626 1.4745 1.78224C1.4745 1.28814 1.87647 0.886268 2.37048 0.886268C2.86458 0.886268 3.26646 1.28823 3.26646 1.78224C3.26655 2.27626 2.86458 2.67822 2.37048 2.67822ZM5.82671 4.34224C6.32063 4.34224 6.72269 4.74421 6.72269 5.23822C6.72269 5.73214 6.32063 6.1342 5.82671 6.1342C5.33261 6.1342 4.93073 5.73214 4.93073 5.23822C4.93055 4.74412 5.33261 4.34224 5.82671 4.34224ZM9.28271 9.59024C8.78879 9.59024 8.38673 9.18819 8.38673 8.69427C8.38673 8.20035 8.78879 7.79829 9.28271 7.79829C9.77663 7.79829 10.1787 8.20035 10.1787 8.69427C10.1787 9.18819 9.77663 9.59024 9.28271 9.59024Z"
          fill="#4791FF"
        />
        <path d="M2.20728 2.6154L1.62326 2.03138L1.98522 1.66941L2.20906 1.89325L2.84406 1.2644L3.20442 1.62834L2.20728 2.6154Z" fill="#4791FF" />
        <path d="M5.62077 6.0023L5.03656 5.4181L5.39871 5.05613L5.62255 5.28006L6.25764 4.65112L6.61791 5.01505L5.62077 6.0023Z" fill="#4791FF" />
        <path d="M9.07791 9.45939L8.49398 8.87537L8.85603 8.5134L9.07979 8.73724L9.71487 8.1084L10.0751 8.47215L9.07791 9.45939Z" fill="#4791FF" />
      </svg>
    ),
    background: "#E0ECFF",
    color: "#4791FF",
  },
  {
    type: "module",
    icon: (
      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.4265 0.192383H2.82654C2.72047 0.192383 2.61868 0.234527 2.54368 0.309526C2.46868 0.384525 2.42654 0.486312 2.42654 0.592383V1.79238H1.22654C1.12047 1.79238 1.01868 1.83453 0.943681 1.90953C0.868682 1.98452 0.826538 2.08631 0.826538 2.19238V11.7924C0.826538 11.8985 0.868682 12.0002 0.943681 12.0752C1.01868 12.1502 1.12047 12.1924 1.22654 12.1924H10.8265C10.9326 12.1924 11.0344 12.1502 11.1094 12.0752C11.1844 12.0002 11.2265 11.8985 11.2265 11.7924V10.5924H12.4265C12.5326 10.5924 12.6344 10.5502 12.7094 10.4752C12.7844 10.4002 12.8265 10.2985 12.8265 10.1924V0.592383C12.8265 0.486312 12.7844 0.384525 12.7094 0.309526C12.6344 0.234527 12.5326 0.192383 12.4265 0.192383ZM10.4265 11.3924H1.62654V2.59238H10.4265V11.3924ZM12.0265 9.79238H11.2265V2.19238C11.2265 2.08631 11.1844 1.98452 11.1094 1.90953C11.0344 1.83453 10.9326 1.79238 10.8265 1.79238H3.22654V0.992383H12.0265V9.79238Z"
          fill="#02BC77"
        />
        <path
          d="M8.36208 4.9643L5.15362 8.17184L3.69077 6.70951C3.58916 6.61138 3.44336 6.57406 3.30711 6.61138C3.17095 6.64879 3.06453 6.75522 3.02711 6.89138C2.98979 7.02763 3.02711 7.17344 3.12524 7.27504L4.87086 9.02023L4.87077 9.02032C4.94577 9.09523 5.04755 9.13737 5.15363 9.13737C5.2597 9.13737 5.36139 9.09523 5.43639 9.02032L8.92759 5.53003V5.52994C9.02572 5.42834 9.06304 5.28254 9.02572 5.14628C8.98831 5.01012 8.88188 4.9037 8.74572 4.86628C8.60947 4.82896 8.46366 4.8662 8.36206 4.96432L8.36208 4.9643Z"
          fill="#02BC77"
        />
      </svg>
    ),
    background: "#D4F4E8",
    color: "#02BC77",
  },
  {
    type: "trigger",
    icon: (
      <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.1 3.31211C12.1 1.98864 11.0235 0.912109 9.69999 0.912109H3.29999C1.97651 0.912109 0.899986 1.98864 0.899986 3.31211C0.899986 4.63558 1.97651 5.71211 3.29999 5.71211C3.52106 5.71211 3.69999 5.53318 3.69999 5.31211C3.69999 5.09104 3.52106 4.91211 3.29999 4.91211C2.41759 4.91211 1.69999 4.19451 1.69999 3.31211C1.69999 2.42971 2.41759 1.71211 3.29999 1.71211H9.69999C10.5824 1.71211 11.3 2.42971 11.3 3.31211C11.3 4.1479 10.654 4.828 9.83615 4.89835L9.81248 4.7313C9.80034 4.64576 9.76132 4.56683 9.70079 4.50549L8.42383 3.2164C8.23436 3.02541 7.98285 2.91987 7.71446 2.91987H7.7141C7.44571 2.91987 7.19373 3.02496 7.00393 3.2164C6.91562 3.30586 6.84732 3.40782 6.79929 3.5172C6.47035 3.44371 6.11179 3.54487 5.86921 3.78952C5.82072 3.83835 5.77858 3.89103 5.74224 3.94657L4.9942 3.19112C4.81598 3.0113 4.57653 2.9121 4.31991 2.9121H4.31955C4.0492 2.9121 3.79375 3.02032 3.59964 3.21637C3.21135 3.6086 3.20001 4.23557 3.57464 4.61324L4.98749 6.04056L4.78088 6.66753C4.73356 6.81047 4.7707 6.96753 4.87624 7.07413L6.01098 8.22021C6.05518 8.26477 6.10866 8.29834 6.16759 8.31789L7.86992 8.89092C7.91171 8.90547 7.9551 8.91208 7.99769 8.91208C8.10278 8.91208 8.20545 8.87065 8.28205 8.79369L9.98438 7.07449C10.0722 6.98538 10.1137 6.86083 10.0961 6.73698L9.9493 5.69895C11.1561 5.57385 12.1 4.55127 12.1 3.31197L12.1 3.31211ZM7.88901 8.0536L6.51285 7.59028L5.61713 6.68564L5.64177 6.61064C5.77025 6.63877 5.90936 6.60323 6.00973 6.50439C6.16633 6.34895 6.16794 6.09536 6.0124 5.93877L4.14285 4.05047C4.07687 3.98405 4.08856 3.85949 4.16821 3.77895C4.23303 3.71333 4.32839 3.65708 4.42563 3.75395L5.76037 5.10243C5.77483 5.11725 5.79046 5.13056 5.80644 5.14225C5.82599 5.16645 5.84706 5.18957 5.8693 5.21216L6.2951 5.64181C6.45019 5.79842 6.70331 5.80002 6.86072 5.64413C7.01733 5.48868 7.01849 5.23556 6.86305 5.07851L6.4377 4.64923C6.35645 4.56718 6.35645 4.43396 6.43734 4.35236C6.5127 4.27584 6.64475 4.27584 6.72011 4.352L6.99083 4.62549C6.99511 4.63013 6.9994 4.63451 7.00413 4.63915L7.42993 5.0688C7.58502 5.2254 7.83814 5.22701 7.99556 5.07112C8.15217 4.91567 8.15332 4.66254 7.99824 4.50549L7.56662 4.06995C7.49163 3.98754 7.49359 3.85861 7.57207 3.77932C7.61037 3.74102 7.66038 3.71995 7.71386 3.71995C7.76698 3.71995 7.81734 3.74102 7.85484 3.77932L9.03886 4.97423L9.27601 6.65235L7.88901 8.0536Z"
          fill="#FF2366"
        />
      </svg>
    ),
    background: "#FFDAE5",
    color: "#FF2366",
  },
  {
    type: "condition",
    icon: (
      <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.9 5.13428H4.5V5.93428H2.9C2.58169 5.93428 2.27653 6.0607 2.05143 6.28571C1.82643 6.5108 1.7 6.81597 1.7 7.13428V9.53428C1.7 9.85259 1.82643 10.1578 2.05143 10.3828C2.27652 10.6079 2.58169 10.7343 2.9 10.7343V11.5343C2.36974 11.5337 1.86142 11.3228 1.48651 10.9478C1.11152 10.5729 0.900617 10.0645 0.9 9.53428V7.13428C0.900625 6.60401 1.11152 6.09569 1.48651 5.72079C1.86142 5.3458 2.36974 5.13489 2.9 5.13428ZM5.7 7.53428V8.33428H10.5V7.53428H5.7ZM8.1 5.93428H5.7V6.73428H8.1V5.93428Z"
          fill="#E1580C"
        />
        <path
          d="M2.9 11.5345H10.1C10.6303 11.5338 11.1386 11.323 11.5135 10.948C11.8885 10.5731 12.0994 10.0647 12.1 9.53447V3.53447C12.1 3.4284 12.0579 3.3267 11.9828 3.2517L9.18277 0.451705C9.10777 0.376614 9.00607 0.334473 8.9 0.334473H6.1C5.56974 0.335098 5.06142 0.54599 4.68652 0.920987C4.31152 1.29589 4.10062 1.80421 4.1 2.33447V9.53447C4.1 9.85278 3.97358 10.1579 3.74857 10.383C3.52348 10.608 3.21831 10.7345 2.9 10.7345L2.9 11.5345ZM11.1343 3.53447H10.0999C9.7816 3.53447 9.47643 3.40804 9.25134 3.18304C9.02634 2.95795 8.89991 2.65278 8.89991 2.33447V1.30009L11.1343 3.53447ZM10.0999 10.7345H4.49991C4.76009 10.3886 4.90043 9.96734 4.89991 9.53447V2.33447C4.89991 2.01616 5.02634 1.711 5.25134 1.4859C5.47643 1.2609 5.7816 1.13447 6.09991 1.13447H8.09991V2.33447C8.10053 2.86473 8.31143 3.37305 8.68642 3.74796C9.06133 4.12295 9.56965 4.33385 10.0999 4.33447H11.2999V9.53447C11.2999 9.85278 11.1735 10.1579 10.9485 10.383C10.7234 10.608 10.4182 10.7345 10.0999 10.7345Z"
          fill="#E1580C"
        />
      </svg>
    ),
    background: "#FFCCB0",
    color: "#E1580C",
  },
  {
    type: "action",
    icon: (
      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.23532 10.2957C3.98594 10.4209 4.74559 10.4837 5.50659 10.4837C6.26758 10.4837 7.02723 10.4209 7.77785 10.2957C8.47361 10.181 9.11588 9.85111 9.61443 9.35256C10.1131 8.85401 10.4428 8.21163 10.5576 7.51587C10.68 6.76728 10.7408 6.00982 10.7391 5.2512C10.739 4.4902 10.6761 3.73056 10.5511 2.97993C10.4364 2.28417 10.1065 1.6419 9.60793 1.14335C9.10938 0.644686 8.467 0.314939 7.77123 0.200185C6.26735 -0.0491504 4.73275 -0.0491504 3.2287 0.200185C2.53305 0.315158 1.8909 0.645007 1.39232 1.14359C0.893776 1.64213 0.563794 2.28429 0.448924 2.97996C0.198335 4.48384 0.198335 6.01873 0.448924 7.52249C0.565266 8.21791 0.896491 8.8595 1.3963 9.35691C1.8961 9.85432 2.53919 10.1826 3.23518 10.2957H3.23532ZM5.50659 1.32687C6.19563 1.32459 6.88363 1.37922 7.56365 1.49032C7.99022 1.56024 8.38409 1.76235 8.68975 2.06803C8.99541 2.3737 9.19755 2.76755 9.26746 3.19413C9.37844 3.87415 9.43307 4.56217 9.43091 5.25119C9.43307 5.94023 9.37844 6.62823 9.26746 7.30825C9.19754 7.73482 8.99542 8.12869 8.68975 8.43435C8.38407 8.74001 7.99022 8.94216 7.56365 9.01206C6.20211 9.2379 4.81263 9.2379 3.45122 9.01206C3.02429 8.94237 2.62999 8.74048 2.32407 8.43479C2.01806 8.1291 1.81571 7.73503 1.74566 7.30822C1.51879 5.9468 1.51879 4.55721 1.74566 3.19579C1.81535 2.76887 2.01723 2.37456 2.32293 2.06864C2.62861 1.76263 3.02269 1.56028 3.44949 1.49023C4.12952 1.37914 4.81754 1.3245 5.50656 1.32678L5.50659 1.32687Z"
          fill="#A423CF"
        />
        <path
          d="M3.8716 5.74163H4.85276V6.72278V6.72267C4.85276 6.95638 4.97742 7.17228 5.17976 7.28919C5.3821 7.40599 5.63145 7.40599 5.83377 7.28919C6.03611 7.17228 6.16077 6.95638 6.16077 6.72267V5.74163H7.14193C7.37563 5.74163 7.59154 5.61696 7.70833 5.41463C7.82513 5.21217 7.82513 4.96283 7.70833 4.7605C7.59154 4.55816 7.37561 4.4335 7.14193 4.4335H6.16077V3.45235C6.16077 3.21875 6.0361 3.00282 5.83377 2.88594C5.63143 2.76914 5.38208 2.76914 5.17976 2.88594C4.97742 3.00285 4.85276 3.21875 4.85276 3.45235V4.4335H3.8716C3.6379 4.4335 3.42199 4.55817 3.30519 4.7605C3.1884 4.96285 3.1884 5.21219 3.30519 5.41463C3.42199 5.61697 3.63792 5.74163 3.8716 5.74163V5.74163Z"
          fill="#A423CF"
        />
      </svg>
    ),
    background: "#F7E2FE",
    color: "#A423CF",
  },
];
